import React, { FC } from 'react';

import { useSearchParams } from 'react-router-dom';

import AdminEntryViewPage from '../../../components/admin/AdminEntryViewPage';
import { MegaExternalEntityResponse } from '../../../models/applications/external-tables';
import { uploadingDataApi } from '../../../redux/api/staff/admin/uploading-data-api';
import { ExternalEntityType } from '../ExternalTablesPage/view';

const mapStringToExternalEntity = new Map<string, ExternalEntityType>([
  ['MOODLE_COURSE', ExternalEntityType.MOODLE_COURSE],
  ['ADMISSION_EDUCATION_LEVEL', ExternalEntityType.ADMISSION_EDUCATION_LEVEL],
  ['CAMPAIGN', ExternalEntityType.CAMPAIGN],
  ['PRIVILEGE_TYPE', ExternalEntityType.PRIVILEGE_TYPE],
  ['PRIVILEGE_TYPE_MAPPING', ExternalEntityType.PRIVILEGE_TYPE_MAPPING],
  ['OLYMPIAD_TYPE', ExternalEntityType.OLYMPIAD_TYPE],
  ['ACHIEVEMENT_TYPE', ExternalEntityType.ACHIEVEMENT_TYPE],
  ['TRAJECTORIES', ExternalEntityType.TRAJECTORIES],
  ['TARGET_ORGANIZATION', ExternalEntityType.TARGET_ORGANIZATION],
  ['EVALUATION_SYSTEM', ExternalEntityType.EVALUATION_SYSTEM],
  ['CONFIRMATION_DOCUMENT_TYPE', ExternalEntityType.CONFIRMATION_DOCUMENT_TYPE],
  ['SUBJECT', ExternalEntityType.SUBJECT],
  ['CONTRACT_PAYMENT_TYPE', ExternalEntityType.CONTRACT_PAYMENT_TYPE],
  ['CONTRACT_SPECIFIC', ExternalEntityType.CONTRACT_SPECIFIC],
  ['ENTRANCE_TEST_TYPE_ENTITY', ExternalEntityType.ENTRANCE_TEST_TYPE_ENTITY],
  ['FACULTY', ExternalEntityType.FACULTY],
  ['DIRECTION_PAYMENT_FORM', ExternalEntityType.DIRECTION_PAYMENT_FORM],
  ['EDUCATION_PROGRAM', ExternalEntityType.EDUCATION_PROGRAM],
  ['DIRECTION_EDUCATION_FORM', ExternalEntityType.DIRECTION_EDUCATION_FORM],
  ['DIRECTION_EDUCATION_LEVEL', ExternalEntityType.DIRECTION_EDUCATION_LEVEL],
  ['DIRECTION', ExternalEntityType.DIRECTION],
  ['ENTRANCE_TESTS_SET', ExternalEntityType.ENTRANCE_TESTS_SET],
]);

const ExternalsView: FC<{
  registry: MegaExternalEntityResponse;
}> = ({ registry }) => {
  return (
    <div className="object-entries-view">
      {Object.keys(registry).map(key => {
        const value = registry[key];
        if (value) {
          return (
            <div className="object-entries-view__entry" key={key}>
              <p>{key}:</p>
              <span className="object-entries-view__value">{value}</span>
            </div>
          );
        }
      })}
    </div>
  );
};

const ExternalTablesEntryPage = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  return (
    <AdminEntryViewPage
      useGetEntryQuery={uploadingDataApi.useGetExternalByIdQuery}
      getBreadcrumbsLabel={() =>
        mapStringToExternalEntity.get(type!) ?? 'Константа'
      }
      extraParams={{ type }}
    >
      {registry => ExternalsView({ registry })}
    </AdminEntryViewPage>
  );
};

export default ExternalTablesEntryPage;
